import React from 'react';
import { assetPlatforms } from '../../Constants/Asset';
import { artifactStatusMap } from '../../Constants/Files';
import LiveStatusIndicator from './LiveStatusIndicator';

// Asset Live status indicator component to display on asset details page.
function AssetLiveStatusIndicator({ asset }) {
	// Check to see if an artifact of a primary source has live status. and add live indicator.
	const primarySrcFile = asset?.sourceFiles?.find((srcFile) => srcFile.isPrimary);
	if (!primarySrcFile) {
		return null;
	}
	const hasPublishedArtifact = asset.artifacts?.some((artifact) => {
		return (
			artifact.sourceFileId === primarySrcFile.id &&
			artifact.status.toLowerCase() === artifactStatusMap.live.value
		);
	});
	if (hasPublishedArtifact) {
		return <LiveStatusIndicator message={assetPlatforms.lowes} />;
	}
	return null;
}

export default AssetLiveStatusIndicator;
